import React from "react";
import { FiAlertOctagon } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { formatarMoeda } from "../../../utils/calculos";
import { formatGargaloLabel } from "../helpers";
import {
  CalibracaoBanner,
  CmdCard,
  CmdCardCta,
  CmdCardHeader,
  CmdCardMetric,
  CmdCardMetrics,
  CmdCardSub,
  CmdCardTitle,
} from "../styles";

export const ROTA_CAPACIDADE_FABRICA = "/legado/capacidade";
export const PERM_CAPACIDADE_FABRICA = "capacidade_fabrica:view";

/**
 * Etapa com mais ambientes na fila (e chegando). A "utilização" que este
 * cartão mostrava dividia a carga por uma capacidade fixa que ninguém
 * calibrou; a capacidade de verdade é a MEDIDA, na página Capacidade da
 * Fábrica — o link aparece só para quem pode abri-la.
 */
export default function GargaloCard({ toc, precosVisiveis }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth() || {};
  const podeVerCapacidade = Boolean(hasPermission?.(PERM_CAPACIDADE_FABRICA));
  const gargalo = toc?.gargalo;
  const snap = toc?.snapshotGargalo;

  return (
    <CmdCard $tone="default">
      <CmdCardHeader>
        <FiAlertOctagon size={13} />
        <span>Etapa com maior carga</span>
      </CmdCardHeader>
      <CmdCardTitle>
        {gargalo ? formatGargaloLabel(gargalo.etapa) : "Nenhuma etapa com fila"}
      </CmdCardTitle>
      {gargalo && (
        <CmdCardSub>
          {gargalo.countWip} na fila + {gargalo.countChegando} chegando, nos próximos{" "}
          {toc?.janelaDiasUteis ?? 7} dias úteis.
        </CmdCardSub>
      )}
      <CmdCardMetrics>
        <CmdCardMetric>
          <span>WIP</span>
          <span>{snap?.wipTotal ?? toc?.totalWip?.count ?? 0}</span>
        </CmdCardMetric>
        <CmdCardMetric>
          <span>Valor em WIP</span>
          <span>
            {precosVisiveis
              ? formatarMoeda(snap?.valorWipRS ?? toc?.totalWip?.valorRS ?? 0)
              : "••••••"}
          </span>
        </CmdCardMetric>
      </CmdCardMetrics>
      {podeVerCapacidade && (
        <CalibracaoBanner
          type="button"
          onClick={() => navigate(ROTA_CAPACIDADE_FABRICA)}
          title="Fila projetada no ritmo real de términos da fábrica"
        >
          Ver a capacidade medida da fábrica
        </CalibracaoBanner>
      )}
      <CmdCardCta type="button" onClick={() => navigate("/kpis-ppcp")}>
        Abrir KPIs PPCP
      </CmdCardCta>
    </CmdCard>
  );
}
